module.exports = __webpack_public_path__ + "img/prize-fsc-light.bfd0a13d.png";